import React, { useState, useEffect, useRef } from "react";
import Pagination from "react-bootstrap/Pagination";
import axiosConn from "config/axiosConn";
import StateList from "../helper/State_List.json";
import DistrictList from "../helper/District_List.json";
import ThemeBaseRouting from "../helper/ThemeBaseRouting";
import common_helper from "../helper/Common_Helper";

function VideoGallery() {
  const [videoData, setVideoData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(9);
  const [playingIndex, setPlayingIndex] = useState(null); // Tracks the currently playing video
  const videoRefs = useRef([]); // Ref to keep track of video elements

  const [stateID, setStateID] = useState("");
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [filteredSchool, setFilteredSchool] = useState([]);
  const [filterData, setFilterData] = useState({
    event_name: "",
    theme_name: "",
    state: "",
    district: "",
    school_name: "",
    videos: true,
  });

  useEffect(() => {
    getThemes();
  }, []);

  const getThemes = async () => {
    try {
      let response = await axiosConn("post", "get-theme-calender", filterData);
      if (response.data.status === "success") {
        const eventsWithVideos = response.data.result?.filter(
          (event) => event.videos && event.videos.length > 0
        );

        const allVideosData = eventsWithVideos?.map((event) => ({
          event_name: event.event_name,
          event_date: event.event_date,
          district: event.district,
          school_name: event.school_name,
          state: event.state,
          theme_name: event.theme_name,
          videos: event.videos, // Keep the list of videos
          _id: event._id,
        }));
        const flattenedVideoData = allVideosData?.flatMap((event) =>
          event.videos.map((video) => ({
            ...event,
            video, // Add each video as a separate entry
          }))
        );
        setVideoData(flattenedVideoData || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const c_post = videoData?.slice(firstPostIndex, lastPostIndex);
  const total_page = Math.ceil(videoData?.length / postPerPage);
  const page_arr = [...Array(total_page).keys()];

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });
    setPlayingIndex(index);
  };

  const handleSelectState = (data) => {
    setStateID(data);
    setFilteredSchool([]);
    let StateName = StateList.find((obj) => obj.state_id == data)?.state_name;
    let filterdistrictList = DistrictList.filter((obj) => obj.state_id == data);
    setFilterDistrict(filterdistrictList);
    setFilterData((prevData) => ({
      ...prevData,
      state: StateName,
      district: "",
      school_name: "",
    }));
    getSchoolList({ state_id: data });
  };

  const handleSelectDistrict = async (value) => {
    setFilteredSchool([]);
    setFilterData((prevData) => ({
      ...prevData,
      district: value,
      school_name: "",
    }));
    let districtid = DistrictList.find(
      (obj) => obj.district_name == value
    )?.district_id;
    getSchoolList({ state_id: stateID, district_id: districtid });
  };

  const handleFilterChange = (field, value) => {
    setFilterData((prevData) => ({ ...prevData, [field]: value }));
  };

  const getSchoolList = async (data) => {
    try {
      let response = await axiosConn("post", "get-school-filter", data);
      if (response.data.status === "success") {
        setFilteredSchool(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="sevenScopeSec">
      <div className="container-fluid">
        <div className="sliderInrHdng" style={{ position: "static" }}>
          <h2>
            Video <span className="hdngBrkr">Gallery</span>
          </h2>
        </div>

        <div className="dashbrdTopSrchDiv">
          <div className="row tab">
            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="card-stats card">
                <select
                  name="theme_name"
                  className="form-control"
                  value={filterData.theme_name}
                  onChange={(e) => {
                    handleFilterChange("theme_name", e.target.value);
                  }}
                >
                  <option value="">Select Theme</option>
                  {ThemeBaseRouting.map((list, i) => (
                    <option value={list.value}>{list.lable}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="card-stats card">
                <select
                  name="state"
                  className="form-control"
                  value={
                    StateList.find(
                      (list) => list.state_name == filterData.state
                    )?.state_id || ""
                  }
                  onChange={(e) => handleSelectState(e.target.value)}
                >
                  <option value="">Select State</option>
                  {StateList.map((list, i) => (
                    <option key={i} value={list.state_id}>
                      {list.state_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="card-stats card">
                <select
                  name="district"
                  className="form-control"
                  value={filterData.district}
                  onChange={(e) => {
                    handleSelectDistrict(e.target.value);
                  }}
                >
                  <option value="">Select District</option>
                  {filterDistrict.map((list, i) => (
                    <option key={i} value={list.district_name}>
                      {list.district_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-2">
              <div className="card-stats card">
                <select
                  name="school_name"
                  className="form-control"
                  value={filterData.school_name}
                  onChange={(e) =>
                    handleFilterChange("school_name", e.target.value)
                  }
                >
                  <option value="">Select School</option>
                  {filteredSchool &&
                    filteredSchool.map((school, i) => (
                      <option key={i} value={school.school_name}>
                        {school.school_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="srchBx _sr1 srchBtn col-12 col-sm-6 col-md-6 col-lg-1">
              <button
                type="submit"
                onClick={() => getThemes()}
                className="button green btn-login-signup loginBtnnewhm hdrBtnSrch"
              >
                Search
              </button>
            </div>
          </div>
        </div>

        <div className="sevenScopeBox newsevenbox mt-5">
          <div className="container-fluid">
            <div className="row">
              {videoData.length > 0 ? (
                c_post?.map((video, index) => (
                  <div key={index} className="col-4 abtSecR">
                    <div className="newabtsenRin">
                      <video
                        width="100%"
                        height="245"
                        controls
                        src={`${videoData[0].video}`}
                        onPlay={() => handlePlay(index)}
                        ref={(el) => (videoRefs.current[index] = el)}
                      />
                      <div className="videoTitle p-3 pt-0 text-start">
                        <p>
                          <b>Event Name</b>:{video.event_name}{" "}
                        </p>
                        <p>
                          <b>school name</b>: {video.school_name}
                        </p>
                        <p>
                          <b>State</b>: {video.state}
                        </p>
                        <p>
                          <b>District</b>: {video.district}
                        </p>
                        <p><b>Event Date & Time</b>:{common_helper.formatDate(video.event_date)}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No videos available.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {videoData ? (
        <div className="d-flex justify-content-center">
          <Pagination>
            {page_arr.map((i, x) => (
              <Pagination.Item
                key={i}
                onClick={() => {
                  setCurrentPage(i + 1);
                }}
                active={i + 1 === currentPage}
              >
                {i + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      ) : (
        <></>
      )}
    </section>
  );
}

export default VideoGallery;
